import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPrettierComponent } from './simple-icons-prettier.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPrettierComponent ],
    exports:      [ SimpleIconsPrettierComponent ],
    bootstrap:    []
})
export class SimpleIconsPrettierModule {}
